import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'navaar-latest-icon', template: `<svg xmlns="http://www.w3.org/2000/svg" width="21" height="13" viewBox="0 0 21 13">
  <rect id="Rectangle_2302" data-name="Rectangle 2302" width="21" height="13" rx="4" fill="#fff"/>
 <text id="new" transform="translate(10 9)" fill="#403f49" font-size="9" font-family="IRANSans-Bold, IRANSans" font-weight="700" letter-spacing="0.016em"><tspan x="8.402" y="0">new</tspan></text>
</svg>
`
})
export class LatestIconComponent  {
  @Input() public style: object = {};
  constructor() { }
}
